module.exports = __webpack_public_path__ + "img/anchorPoint_play_icon1.f1108e58.png";